var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAtom } from 'jotai';
import MainContext from '../../../../Context';
import isDCHEligible from '../../../../helpers/isDCHEligible';
import { multiPaymentStateAtom } from '../../../../store/multiPaymentAtoms';
import { t } from '../../../../strings/i18n';
import PaymentMethodSelect from './PaymentMethodSelect';
const SettlementPaymentMethodSelect = ({ fieldNamePrefix, accountSummaryQueryResult, paymentMethodsQueryResult }) => {
    var _a;
    const { featureFlags } = useContext(MainContext);
    const { control } = useFormContext();
    const [, setMultiPaymentState] = useAtom(multiPaymentStateAtom);
    const { billing, product } = accountSummaryQueryResult;
    const paymentMethods = (_a = paymentMethodsQueryResult === null || paymentMethodsQueryResult === void 0 ? void 0 : paymentMethodsQueryResult.paymentMethods) !== null && _a !== void 0 ? _a : [];
    const isDCHAccount = isDCHEligible(billing, product.type, featureFlags);
    const filteredPaymentMethods = paymentMethods.filter((paymentMethod) => {
        return paymentMethod.paymentMedium !== 'PINLESS_DEBIT_CARD';
    });
    return (_jsx(Controller, { control: control, name: `${fieldNamePrefix}.paymentMethod`, render: ({ field, fieldState: { error } }) => {
            const { ref } = field, fieldProps = __rest(field, ["ref"]);
            return (_jsx(PaymentMethodSelect, { error: error, field: fieldProps, paymentMethods: isDCHAccount ? filteredPaymentMethods : paymentMethods, onChange: (value) => {
                    field.onChange(value);
                    setMultiPaymentState((multiPaymentState) => (Object.assign(Object.assign({}, multiPaymentState), { [fieldNamePrefix]: Object.assign(Object.assign({}, multiPaymentState[fieldNamePrefix]), { paymentMethod: value }) })));
                } }));
        }, rules: {
            required: t('errors.paymentMethod')
        } }));
};
export default SettlementPaymentMethodSelect;
